<script setup>
import {computed} from "vue";
import StatCard from "@/components/global-themed/StatCard.vue";
import BaseCard from "@/components/global-themed/BaseCard.vue";
import {usePyCrawlFormatters} from "@/composables/admin/usePyCrawlAnalytics";

const props = defineProps({
    jobs: {type: Object, required: true},
    pages: {type: Object, required: true},
    performance: {type: Object, required: true},
});

const {formatCount, formatRate, formatDuration} = usePyCrawlFormatters();

const blockedRate = computed(() => {
    const total = props.jobs.blocked_last_7_days + props.jobs.completed_last_7_days;
    if (!total) {
        return null;
    }
    return props.jobs.blocked_last_7_days / total;
});

const completedRate = computed(() => {
    const total = props.jobs.completed_last_7_days + props.jobs.blocked_last_7_days;
    if (!total) {
        return null;
    }
    return props.jobs.completed_last_7_days / total;
});
</script>

<template>
  <BaseCard>
    <h2 class="tw-text-xl tw-font-semibold tw-text-font-primary tw-mb-4">
      Last 7 Days
    </h2>
    <div class="tw-grid tw-grid-cols-4 tw-gap-3 tw-mb-3">
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(jobs.completed_last_7_days) }}
        </template>
        <template #title>
          Jobs Completed ({{ formatRate(completedRate) }})
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(jobs.failed_last_7_days) }}
        </template>
        <template #title>
          Jobs Failed
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(jobs.blocked_last_7_days) }}
        </template>
        <template #title>
          Jobs Blocked ({{ formatRate(blockedRate) }})
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatRate(jobs.success_rate_last_7_days) }}
        </template>
        <template #title>
          Success Rate
        </template>
      </StatCard>
    </div>
    <div class="tw-grid tw-grid-cols-4 tw-gap-3">
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(pages.crawled_last_7_days) }}
        </template>
        <template #title>
          Pages Crawled
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatCount(pages.avg_per_job_last_7_days) }}
        </template>
        <template #title>
          Avg Pages / Job
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatDuration(performance.avg_duration_seconds_last_7_days) }}
        </template>
        <template #title>
          Avg Duration
        </template>
      </StatCard>
      <StatCard variant="tight">
        <template #stat>
          {{ formatDuration(performance.p95_duration_seconds_last_7_days) }}
        </template>
        <template #title>
          P95 Duration
        </template>
      </StatCard>
    </div>
  </BaseCard>
</template>
